import { render, staticRenderFns } from "./scrollTable.vue?vue&type=template&id=b45a41ba&scoped=true"
import script from "./scrollTable.vue?vue&type=script&lang=js"
export * from "./scrollTable.vue?vue&type=script&lang=js"
import style0 from "./scrollTable.vue?vue&type=style&index=0&id=b45a41ba&prod&lang=less"
import style1 from "./scrollTable.vue?vue&type=style&index=1&id=b45a41ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a41ba",
  null
  
)

export default component.exports